export default "__VITE_ASSET__D4l8IO2D__"